import { useState } from "react";
import { Button, Input } from "@heroui/react";
import { IconAlertTriangle } from "@tabler/icons-react";
import toast from "react-hot-toast";
import { useTranslations } from "../../../../i18n";
// import GoogleSigninBtn from "./google-signin-btn";
import { useViewStore } from "../../../store/view-store";
import { useAuthStore } from "../../../store/auth-store";
import { api, ApiError } from "../../../lib/api";
import { useStudioStore } from "../../../store/studio-store";

function LoginForm() {
  const studio = useStudioStore((state) => state.studio);
  const t = useTranslations("auth");

  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState(""); // "farid.rehila@proton.me"
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const { login } = useAuthStore();

  const { navigate } = useViewStore();

  const onForgotPassword = () => {
    navigate(`password`);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError(t("fill-email-password"));
      return;
    }

    try {
      setIsLoading(true);

      const session = await api("/api/widget/auth/login", {
        method: "POST",
        body: JSON.stringify({
          email,
          password,
          studioId: studio?.id, // ← IMPORTANT for tenant scoping
        }),
      });

      // Store session in widget auth store
      login({
        user: {
          id: session.user.id,
          name: session.user.name ?? null,
          email: session.user.email,
        },
        token: session.token,
      });

      toast.success(t("login-successful"));

      // Continue widget flow
      useViewStore.getState().onLoginSuccess();
    } catch (err) {
      console.error("Login error:", err);
      setError(
        err instanceof ApiError && err.code === "RATE_LIMITED"
          ? t("too-many-attempts")
          : t("login-failed"),
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md mx-auto mt-6">
      {error && (
        <div className="flex items-start gap-2 border-1 border-red-500 rounded-md p-2 mb-4">
          <IconAlertTriangle className="text-red-500" />
          <p className="text-sm">{error}</p>
        </div>
      )}
      <div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <Input
            type="email"
            label={t("email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            type="password"
            label={t("password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <div className="flex justify-end mb-2">
            <Button
              variant="light"
              color="primary"
              className="text-sm text-blue-600 hover:text-blue-800"
              onPress={onForgotPassword}
            >
              {t("forgot-password")}
            </Button>
          </div>

          <Button
            isDisabled={isLoading}
            type="submit"
            color="primary"
            className="h-12"
            isLoading={isLoading}
          >
            {t("login")}
          </Button>
        </form>

        {/* <div className="flex items-center gap-2 my-4">
          <div className="flex-1 h-px bg-divider" />
          <span className="text-xs text-default-400">{t("or")}</span>
          <div className="flex-1 h-px bg-divider" />
        </div>

        <GoogleSigninBtn /> */}
      </div>
    </div>
  );
}

export default LoginForm;
